import { useTranslation } from "react-i18next";
import { Button } from "@monorepo/components";
import { ANALYTICS_COOKIE_NAME, HOSTNAME } from "@monorepo/constants";

import { SAnalyticsAgreementButtonWrapper, SAnalyticsCookieBanner } from "./AnalyticsCookieBanner.styles";

export const AnalyticsCookieBanner = () => {
  const { t } = useTranslation();
  const setCookieValue = (value: boolean) => {
    const cookieDomain = HOSTNAME?.includes("localhost") ? ".localhost" : ".perlasgo.lt";
    document.cookie = `${ANALYTICS_COOKIE_NAME}=${String(value)};max-age=604800;domain=${cookieDomain}`;
    window.location.reload();
  };

  return (
    <SAnalyticsCookieBanner>
      <p>
        {t("agreements.analytics_banner")}
        <a target="blank" href="https://www.perlasgo.lt/privatumo-politika/">
          {t("agreements.privacy_policy_and_cookies")}
        </a>
      </p>
      <SAnalyticsAgreementButtonWrapper>
        <Button variant="secondary" onClick={() => setCookieValue(false)}>
          {t("common.i_disagree")}
        </Button>
        <Button onClick={() => setCookieValue(true)}>{t("common.i_agree")}</Button>
      </SAnalyticsAgreementButtonWrapper>
    </SAnalyticsCookieBanner>
  );
};
